import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-upload-color",
  "use": "rt-base-upload-color-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-upload-color\"><path d=\"M811.3 342.7C765.6 216.9 646 133 512.1 133s-253.5 83.8-299.2 209.6C115.6 369.7 52.9 464 65.7 564.2c12.7 100.2 97.1 175.8 198 177.6H760c100.9-1.8 185.3-77.3 198.1-177.4 12.9-100.1-49.6-194.5-146.8-221.7z\" fill=\"#1890FF\" opacity=\".5\" /><path d=\"M657.8 562.2L540.7 445.8c-19.1-18.9-49.8-18.9-68.9 0L354.7 562.2c-4.7 4.7-4.7 12.4 0 17.1 2.3 2.3 5.4 3.6 8.6 3.5h82V879c0 6.7 5.5 12.1 12.2 12.1H555c6.7 0 12.2-5.4 12.2-12.1V582.9h82c6.7 0 12.1-5.4 12.2-12.1 0-3.2-1.3-6.3-3.6-8.6z\" fill=\"#53A4FC\" opacity=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/upload-color.svg
// module id = 1763
// module chunks = 228